import moment from 'moment';

import { Storage } from '@/enums/storage.enum';
import router from '@/router';
import { getTokenData } from './tokenData';

/**
 * Przekierowanie po poprwanym logowaniu
 *
 * @export
 */
export function redirectAfterLogin() {
  const tokenData = getTokenData();
  if (tokenData?.user?.passwordValidUntil && moment().isAfter(tokenData.user.passwordValidUntil)) {
    return router.push({ name: 'updatePassword' });
  }

  const redirect = sessionStorage.getItem(Storage.REDIRECT);
  sessionStorage.removeItem(Storage.REDIRECT);
  if (redirect) {
    return router.push(JSON.parse(redirect));
  }

  router.push({ name: 'myProfile' });
}
